import { logAmplitudeClickEvent } from 'chairisher/util/analytics';

/**
 * Specifies where a private deal accept originated
 *
 * @enum {string}
 */
export const PrivateDealSource = {
    BSC: 'BSC',
    PDP: 'PDP',
};

/**
 * Appends private deal data to MAO forms
 *
 * @param {number} privateDealId ID of private deal
 * @param {string} source Indication of where private deal is rendered
 */
export function setPrivateDealParamsOnMaoForms(privateDealId, source) {
    const maoForms = document.querySelectorAll('.js-make-offer-form');
    maoForms.forEach((maoForm) => {
        const form = maoForm;
        const currentUrl = new URL(maoForm.action, window.location.origin);
        const queryParams = currentUrl.searchParams;

        queryParams.set('private_deal_id', privateDealId);

        if (!queryParams.get('source') && source) {
            queryParams.set('source', source);
        }

        currentUrl.search = queryParams.toString();

        form.action = currentUrl.pathname + currentUrl.search;
    });
}

/**
 * Renders a private deal for a product.
 *
 * @param {Object} productData Product data Object
 * @param {string} source Indication of where private deal is rendered
 */
export function renderPrivateDeal(productData, source) {
    const privateDealData = productData.meta.private_deal;

    // expiration details
    document.querySelector('.js-product-private-deal-expiry').textContent = privateDealData.expires_in;

    // price details
    document.querySelector('.js-product-price-current-value').textContent = privateDealData.price.display;
    document.querySelector('.js-product-price-previous-value').textContent = productData.meta.your_price.current.value;

    // link href to accept offer
    const ctaLink = document.querySelector('.js-product-private-deal-accept-link');
    const href = source ? `${privateDealData.cta_url}&source=${source}` : privateDealData.cta_url;
    ctaLink.setAttribute('href', href);
    ctaLink.addEventListener('click', () => logAmplitudeClickEvent('Accept Private Deal', source, href));
    setPrivateDealParamsOnMaoForms(privateDealData.id, source);

    document.querySelector('.js-product-private-deal-container').classList.remove('hidden');
}
